import React, { useState, useEffect } from "react";
import arrow from "../../assets/arrow-down.png";

const ToTop = () => {
    const [isVisible, setIsVisible] = useState(false);

    const toggleVisibility = () => {
        if (window.pageYOffset > 300) {
            setIsVisible(true);
        } else {
            setIsVisible(false);
        }
    };

    const scrollToTop = () => {
        window.scrollTo({
            top: 0,
            behavior: "smooth"
        });
    };

    useEffect(() => {
        window.addEventListener("scroll", toggleVisibility);
        return () => {
            window.removeEventListener("scroll", toggleVisibility);
        };
    }, []);

    return (
        <div 
            className={`toTop ${isVisible ? "visible" : "hidden"}`}
            onClick={scrollToTop}
        >
            <img src={arrow} alt="Go to top" className="toTop__arrow" />
        </div>
    );
}

export default ToTop;